module.exports = __webpack_public_path__ + "img/628d911.jpg";